class NewAddToCart {
    constructor() {
        this.button = document.querySelector(
            'form.product-buy-buttons--form[id*="template--"] #add-to-cart-button'
        );

        this.freeProductVariantId = '45489477681328';

        this.init();
    }

    init() {
        if (!this.button) return;

        this.button.addEventListener(
            'click',
            this.handleSubmit.bind(this)
        );
    }

    // Cart me free product already hai ya nahi ye check karega
    async isFreeProductInCart() {
        try {
            const response = await fetch('/cart.js');
            const cart = await response.json();

            return cart.items.some(
                (item) =>
                    String(item.variant_id) ===
                    String(this.freeProductVariantId)
            );
        } catch (error) {
            console.error('Cart Check Error:', error);
            // Agar check fail ho jaye to safe side lene ke liye false return karo
            // (taaki free product add ho jaye, missing na ho jaye)
            return false;
        }
    }

    async handleSubmit(event) {
        event.preventDefault();

        const button = event.currentTarget;
        const form = button.closest('form.product-buy-buttons--form');

        const spinner = button.querySelector('#loadingSpinnerPdp');
        const buttonText = button.querySelector('#buttonTextPdp');

        // Get form values
        const variantId = form.querySelector('[name="id"]')?.value;

        const quantity = parseInt(
            form.querySelector('[name="quantity"]')?.value || 1
        );

        const productType = form.querySelector(
            '[name="product_type"]'
        )?.value;

        const isMattress =
            productType === 'MATTRESS' ||
            productType === 'Mattress';

        // Show Loader
        if (spinner) spinner.style.display = 'block';
        if (buttonText) buttonText.style.display = 'none';

        button.disabled = true;

        try {
            console.log('Variant ID:', variantId);
            console.log('Quantity:', quantity);
            console.log('Product Type:', productType);
            console.log('Is Mattress:', isMattress);

            /*
             * ==========================================
             * MATTRESS
             * ==========================================
             *
             * Mattress hai to:
             * 1. Mattress add (hamesha)
             * 2. Free product add — SIRF agar cart me pehle se nahi hai
             */

            if (isMattress) {

                const alreadyHasFreeProduct = await this.isFreeProductInCart();

                console.log(
                    'Free Product Already In Cart:',
                    alreadyHasFreeProduct
                );

                const items = [
                    {
                        id: variantId,
                        quantity: quantity,
                        properties: {
                            _is_mattress: true
                        }
                    }
                ];

                // Free product tabhi push karo jab cart me already na ho
                if (!alreadyHasFreeProduct) {
                    items.push({
                        id: this.freeProductVariantId,
                        quantity: 1,
                        properties: {
                            _free_product: true
                        }
                    });
                }

                const payload = { items };

                console.log('Mattress Payload:', payload);

                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify(payload)
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    console.error('Cart Add Error:', errorData);

                    throw new Error(
                        errorData.description ||
                        'Failed to add mattress to cart'
                    );
                }

                const data = await response.json();

                console.log('Mattress Added:', data);

            } else {

                /*
                 * ==========================================
                 * NORMAL PRODUCT
                 * ==========================================
                 */

                const payload = {
                    items: [
                        {
                            id: variantId,
                            quantity: quantity,
                            properties: {
                                _is_mattress: false
                            }
                        }
                    ]
                };

                console.log('Normal Product Payload:', payload);

                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify(payload)
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    console.error('Cart Add Error:', errorData);

                    throw new Error(
                        errorData.description ||
                        'Failed to add product to cart'
                    );
                }

                const data = await response.json();

                console.log('Product Added:', data);
            }

            /*
             * ==========================================
             * REFRESH SIDE CART
             * ==========================================
             */

            document.dispatchEvent(
                new CustomEvent('side-cart:drawer:refresh', {
                    detail: {
                        onComplete: () => {
                            document.dispatchEvent(
                                new Event('side-cart:drawer:open')
                            );
                        }
                    }
                })
            );

        } catch (error) {

            console.error('Add To Cart Error:', error);

        } finally {

            // Hide Loader
            if (spinner) spinner.style.display = 'none';
            if (buttonText) buttonText.style.display = 'block';

            button.disabled = false;
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new NewAddToCart();
});